import { Geolocation } from "types/apiTypes";

export const getUserGeolocationInfo = async (): Promise<Geolocation> => {
  const resp = await fetch(`/api/geolocation/p_get_user_info`);
  const result = await resp.json();
  return result;
};
